import styles from "./styles.module.css";
import { useEffect, useState, useContext } from "react";
import { AppDisbatch } from "../../../contexts/app";
import { makeid } from "../../../utils/pageactions";

export default function CustomProps({ block, path, onChange }) {
  const [events, setEvents] = useState({});
  const disbatch = useContext(AppDisbatch);

  useEffect(() => {
    if (block.customEvents) {
      setEvents(block.customEvents);
    }
  }, [block.customEvents]);

  const handleChange = (events) => {
    const newBlock = { ...block };
    newBlock.customEvents = events;
    onChange(newBlock);
    console.log(events);
    disbatch({
      type: "updateComponent",
      component: { id: block.id, key: "customEvents", value: events },
    });
  };

  const handleAdd = () => {
    const id = makeid(16);
    const newEvents = { ...events };
    newEvents[id] = { name: id, displayName: "" };
    setEvents(newEvents);
    handleChange(newEvents);
  };

  const handleUpdate = (v, i) => {
    const newEvents = { ...events };
    newEvents[i] = v;
    setEvents(newEvents);
    handleChange(newEvents);
  };

  const handleDelete = (i) => {
    const newEvents = { ...events };
    delete newEvents[i];
    setEvents(newEvents);
    handleChange(newEvents);
  };
  return (
    <div
      style={{ display: "flex", flexDirection: "column" }}
      className={styles.propInput}
    >
      <div className={styles.propTitle}>Custom Events</div>
      {Object.keys(events).map((k) => {
        return (
          <PropItem
            id={k}
            value={events[k]}
            key={k}
            onDelete={() => handleDelete(k)}
            onChange={(v) => handleUpdate(v, k)}
          />
        );
      })}
      <div onClick={handleAdd} className={styles.addProp}>
        Add Event
      </div>
    </div>
  );
}

const PropItem = ({ value, id, onChange, onDelete }) => {
  const [name, setName] = useState(value.displayName);

  const changeName = () => {
    const newValue = { ...value };
    newValue.displayName = name;
    onChange(newValue);
  };

  return (
    <div className={styles.propItem}>
      <div>
        <div className={styles.propName}>Event Name</div>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          className={"input"}
          onBlur={changeName}
        />
      </div>

      <div onClick={onDelete} className={styles.delete}>
        Delete
      </div>
    </div>
  );
};
